// a utility hook that provides a stateful access to the current viewer

import {clientSideRelayFetchQueryRetained} from '@github-ui/relay-environment'
import {IS_SERVER} from '@github-ui/ssr-utils'
import {useUser} from '@github-ui/use-user'
import {useState} from 'react'
import {useRelayEnvironment} from 'react-relay'
import {graphql} from 'relay-runtime'

import {type AssigneePickerAssignee, readAssigneeFromFragment} from '../AssigneePicker'
import type {
  useViewerSafeViewerSharedQuery,
  useViewerSafeViewerSharedQuery$data,
} from './__generated__/useViewerSafeViewerSharedQuery.graphql'

// it will use the relay store to first look for the data and do a query over the network if needed
export function useViewer(): AssigneePickerAssignee | null {
  const environment = useRelayEnvironment()
  const {currentUser} = useUser()
  // before making a request, try get the viewer via the `useUser` hook that can provide this value
  // based on the app payload - this is not always possible, e.g. in memex the app payload is not
  // used so a request must be sent in this case
  const [viewer, setViewer] = useState<AssigneePickerAssignee | null>(currentUser as AssigneePickerAssignee | null)

  if (!IS_SERVER && !viewer) {
    clientSideRelayFetchQueryRetained<useViewerSafeViewerSharedQuery>({
      environment,
      // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
      query: graphql`
        query useViewerSafeViewerSharedQuery {
          safeViewer {
            ...AssigneePickerSharedAssignee
          }
        }
      `,
      variables: {},
    }).subscribe({
      next: (data: useViewerSafeViewerSharedQuery$data) => {
        if (data.safeViewer) {
          const currentViewer = readAssigneeFromFragment(data.safeViewer)
          setViewer(currentViewer)
        }
      },
    })
  }

  return viewer
}
